<template>
  <div class="container">
    <h1>test</h1>
    <h1 class="page-header">My Login Activity</h1>

    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <tr>
          <th>Name</th>
          <th>Value</th>
        </tr>
        <tr v-for=" (item, key) of userAttrs" :key="item" class="active">
          <td>{{ key }}</td>
          <td>{{ item }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
import { mapState } from "vuex";

export default {
  Name: "UserData",
  components: {},
  methods: {},
  computed: {
    ...mapState(["user"]),
    userAttrs: function() {
      return this.user.attributes;
    }
  }
};
</script>